<template>
    <div class="cd-section" id="features" >
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/404header2.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h1 class="title">404 Not Found</h1>
                        <h3></h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section-about-us">
            <div class="container">
                <div class="row">
                    
                    <div class="col-md-12 ml-auto mr-auto text-center">
                        <h2 class="title">How did you get here?</h2>
                        <h5 class="description">The page you are looking for does not exist.</h5>
                        <img src="img/404.jpg"/>
                    </div>
                    
                </div>
                
            </div>
        </div>

        <!--     *********    CONTACT US 1     *********      -->
        <contact></contact>
        
        <!--     *********    END CONTACT US 1      *********      -->
    </div>
</template>
<script>
  import Contact from './components/Contact'
  import { Card, InfoSection } from '@/components';
  import { Carousel, CarouselItem, Tooltip } from 'element-ui'

  export default {
    name: 'presentation',
    bodyClass: 'presentation-page',
    components: {
      Contact,
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
    },
  }


</script>
<style scoped>
@media (max-width: 768px){
    h1.title{
        font-size:5em;
    }
}
@media screen and (min-width: 991px){
    h1.title{
        font-size:7em;
    }
}
@media screen and (max-width: 576px){
    h1.title{
        font-size:3.5em;
    }
}
</style>